// ─────────────────────────────────────────────────────────────
// ZIFEK — Type de résultat renvoyé par l'assistant IA
// Partagé par le chat client et la fiche commerce (les deux peuvent
// afficher un produit et l'ajouter au panier).
// ─────────────────────────────────────────────────────────────

export interface ChatBoutique {
  id: number;
  name: string;
  user_name: string;
  telephone?: string;
  ville?: string;
  pays?: string;
  image?: string;
  /** Devise du marchand (monnaie du commerce). */
  currency?: string | null;
  url: string;
  /** Marketplace sur laquelle le vendeur est rattaché (là où il vend). */
  marketplace?: { id: number; name: string } | null;
}

export interface ChatSearchResult {
  type: string;
  id: number;
  name: string;
  description?: string;
  price?: number;
  discount_price?: number;
  discount_enabled?: boolean;
  currency?: string | null;
  stock?: number | null;
  stock_tracking_enabled?: boolean;
  product_type?: string | null;
  duration?: number;
  location?: string;
  ville?: string;
  pays?: string;
  image?: string;
  media?: string | Array<{ url?: string } | string> | null;
  videos?: Array<{ url?: string } | string> | string | null;
  category?: string;
  /** Origine du contenu : catalogue classique ou marketplace (table annonce). */
  source?: 'marketplace' | 'classique';
  boutique?: ChatBoutique | null;
}

/**
 * Un produit est en rupture de stock lorsque le suivi de stock est activé,
 * qu'il n'est pas digital et que la quantité restante est nulle ou négative.
 * Dans ce cas, la commande est bloquée dans le chat.
 */
export function isOutOfStock(r: ChatSearchResult | null | undefined): boolean {
  if (!r || r.type !== 'produit') return false;
  if (r.product_type === 'digital') return false;
  if (!r.stock_tracking_enabled) return false;
  return (Number(r.stock ?? 0) || 0) <= 0;
}

/** Prix effectif affiché (promo si activée). */
export function effectivePrice(r: ChatSearchResult): number {
  if (r.discount_enabled && r.discount_price != null) return Number(r.discount_price) || 0;
  return Number(r.price) || 0;
}